<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Language' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label>{{'Language' | translate}}</label>
      <ng-template #lt let-r="result" let-t="term">
        <ngb-highlight [result]=" r['name']" [term]="t"></ngb-highlight>
      </ng-template>
      <input #languageTypeaheadInput class="form-control" [ngbTypeahead]="languageTypeahead" (selectItem)="setLanguage($event)" [editable]='false' [resultTemplate]="lt" [inputFormatter]="formatter" />
      <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'languageCode')">
        <p>{{'Please select language' | translate}}</p>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th class="text-left align-middle">{{'Level' | translate}}</th>
          <th class="text-center align-middle">{{'Speech' | translate}}</th>
          <th class="text-center align-middle">{{'Reading' | translate}}</th>
          <th class="text-center align-middle">{{'Writing' | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let level of languageLevels">
          <td class="text-left align-middle">{{level.label | translate}}</td>
          <td class="text-center align-middle">
            <input type="radio" name="speakingProficiency" [(ngModel)]="entity.speakingProficiency" [value]="level.value">
          </td>
          <td class="text-center align-middle">
            <input type="radio" name="readingProficiency" [(ngModel)]="entity.readingProficiency" [value]="level.value">
          </td>
          <td class="text-center align-middle">
            <input type="radio" name="writingProficiency" [(ngModel)]="entity.writingProficiency" [value]="level.value">
          </td>
        </tr>
      </tbody>
    </table>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Back' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
